module.exports = __webpack_public_path__ + "img/329.d833c1ed.svg";